module.exports = __webpack_public_path__ + "images/71b3947a0814fe20ed3805df982fbf68-RE113_lineart_CarbonMonoxide.png";